import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import { useState } from 'react'
import ButtonCinestar from '../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import Icon from '../../../../components/Icon/Icon'
import InputText from '../../../../components/Inputs/InputText/InputText'
import Typography from '../../../../components/Typography/Typography'
import './GiftVoucher.scss'
import hocConnect from './hocConnect'

import CameraQrLoader from './CameraQrLoader/CameraQrLoader'

const GiftVoucher = ({ qrLoaded, ticketVoucherAdd }) => {
    const intl = useIntl()
    const [voucherNumber, setVoucherNumber] = useState('')

    return (
        <Container fluid className="gift-voucher d-flex flex-column position-relative">
            <div className="d-flex align-items-center justify-content-between ">
                <img src={'images/cards/vip-card.png'} alt={'voucher'} className={'gift-voucher--card'} />

                <div>
                    {/* <div className="gift-voucher__top d-flex"> */}
                    <Typography variant={'sectionHeadline'}>
                        {intl.formatMessage({ id: 'orderSummary.giftVoucher.title' })}
                    </Typography>
                    <div className="d-flex align-items-center gap-2">
                        <Typography variant={'p'}>
                            {intl.formatMessage({ id: 'orderSummary.giftVoucher.info' })}
                        </Typography>
                        <Icon name={'info-lightblue'} />
                    </div>
                </div>
            </div>

            <div className="border-top opacity-50" />
            <div className="gift-voucher__bottom d-flex">
                <div className="gift-voucher__bottom--camera d-flex">
                    <div className="d-flex flex-column justify-content-end w-100">
                        <Typography variant={'formLabel'} className={'mb-1'}>
                            {intl.formatMessage({ id: 'orderSummary.giftVoucher.byPhoto' })}
                        </Typography>
                        <div>
                            <CameraQrLoader loadTicket={ticketVoucherAdd} />
                        </div>
                    </div>
                    <InputText
                        label={intl.formatMessage({ id: 'orderSummary.giftVoucher.byHand' })}
                        placeholder={intl.formatMessage({ id: 'orderSummary.giftVoucher.number' })}
                        className={'mt-auto'}
                        onChange={(e) => setVoucherNumber(e.target.value)}
                        value={voucherNumber}
                    />
                </div>
                <ButtonCinestar
                    variant={'primary-v2'}
                    className={'mt-auto text-nowrap'}
                    disabled={false}
                    onClick={() => ticketVoucherAdd({ voucher_number: voucherNumber })}
                >
                    {intl.formatMessage({ id: 'buttons.confirmVoucher' })}
                </ButtonCinestar>
            </div>
        </Container>
    )
}

export default hocConnect(GiftVoucher)
